/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2025-04-15T17:15:33.285
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import request from '@/plugins/request';

export function listReportMonthRentHouseBigInit(data){return request({
url: '/report/api/reportMonthRentHouseBig/listReportMonthRentHouseBigInit',
method: 'post',
data:data,
});
}


export function listReportMonthRentHouseBigByAuthorizations(data){return request({
url: '/report/api/reportMonthRentHouseBig/listReportMonthRentHouseBigByAuthorizations',
method: 'post',
data:data,
});
}


export function listReportMonthRentHouseBig(data){return request({
url: '/report/api/reportMonthRentHouseBig/listReportMonthRentHouseBig',
method: 'post',
data:data,
});
}


export function getReportMonthRentHouseBigCreateInit(){return request({
url: '/report/api/reportMonthRentHouseBig/getReportMonthRentHouseBigCreateInit',
method: 'post',
});
}


export function getReportMonthRentHouseBigEditInit(params){return request({
url: '/report/api/reportMonthRentHouseBig/getReportMonthRentHouseBigEditInit',
method: 'post',
params:params,
});
}


export function getReportMonthRentHouseBigView(params){return request({
url: '/report/api/reportMonthRentHouseBig/getReportMonthRentHouseBigView',
method: 'post',
params:params,
});
}


export function saveReportMonthRentHouseBig(data){return request({
url: '/report/api/reportMonthRentHouseBig/saveReportMonthRentHouseBig',
method: 'post',
data:data,
});
}


export function deleteReportMonthRentHouseBig(params){return request({
url: '/report/api/reportMonthRentHouseBig/deleteReportMonthRentHouseBig',
method: 'post',
params:params,
});
}


